import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import Typography from "@material-ui/core/Typography";
import { spacing } from "@material-ui/system";
import { Box, Switch } from "@material-ui/core";
import MaskedInput from 'react-text-mask';
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import Input from '@material-ui/core/Input';
import { DropzoneArea } from "material-ui-dropzone";
import Divider from '@material-ui/core/Divider';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Geographical from "../../../constants/Geographical.json";
import { useStyles } from "../../../styles/styles";
import { selectStyles, MenuProps } from "./SelectStyle";
import Calendar from '@sbmdkl/nepali-datepicker-reactjs';
import '@sbmdkl/nepali-datepicker-reactjs/dist/index.css';
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import "nepali-datepicker-reactjs/dist/index.css"
import NepaliDate from 'nepali-date-converter'

export default function ApplicationTemplate({ setFormValuesLicensePOE, formValuesLicensePOE, setDropZoneValue, dropZoneValue, field, configItem, hydroItem, setHydroItem, checkStatus, setCheckStatus, status, setStatus,
    eastError, setEastError, eastStatus, setEastStatus,
     westError, setWestError, westStatus, setWestStatus, 
     northError, setNorthError, northStatus, setNorthStatus, 
    southError, setSouthError, southStatus, setSouthStatus, groupName, groupDescription, stateFlag, setStateFlag, districtFlag, setDistrictFlag }) {
    const classes = useStyles();
    const classesSelect = selectStyles();
    const [customUrl, setCustomUrl] = useState('');
    const [fileStatus, setFileStatus] = useState(true);
    const [description, setDescription] = useState('');
    const [riverShow, setRiverShow] = useState(true);
    const [geos, setGeo] = useState([]);
    const [fromBS, setFromBS] = useState("");
    const [toBS, setToBS] = useState("");
    const [date_of_commencing_the_workBS, setDate_of_commencing_the_workBS] = useState("");
    const [date_of_completing_the_workBS, setDate_of_completing_the_workBS] = useState("");
    const [license_issue_dateBS, setLicense_issue_dateBS] = useState("");
    const [currentDate,setCurrentDate]=useState("")
    const handleInputChangeDropzone1 = (slug, e) => {
          
        setCheckStatus(false);
        setFormValuesLicensePOE({
            ...formValuesLicensePOE,
            [slug]: e,
        });
        setDropZoneValue({
            ...dropZoneValue,
            [slug]: e,
        });

    };

    const handleInputChange = (e) => {
        e.preventDefault();

        const { name, value } = e.target;
        if (["state_1","state_2","state_3"].includes(name)) {
            const districtFilter = [];
            let district_slug = "district_" + name.split('_')[1];
            let municipality_slug = "municipality_" + name.split('_')[1];
            geos.forEach((geo)=>{
                if(value.includes(geo.id)){
                    districtFilter.push(...geo.districts)
                   
                }
                

            })
            districtFilter.sort((a,b)=>a.name.localeCompare(b.name))
            const municipalityFilter = districtFilter.filter((district) => formValuesLicensePOE[district_slug].includes(district.id)).flatMap(district=>district.municipalities);
            
            municipalityFilter.sort((a, b) => a.name.localeCompare(b.name))

            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]:value,
                districtFilter,
                municipalityFilter: municipalityFilter,
                [district_slug]: districtFilter.filter((district) => formValuesLicensePOE[district_slug].includes(district.id)).map(district=>district.id),
                [municipality_slug]: municipalityFilter.filter((municipality) => formValuesLicensePOE[municipality_slug].includes(municipality.id)).map(municipality => municipality.id)
            })
            
           

        } else if (["district_1", "district_2", "district_3"].includes(name)) {
            const municipalityFilter = [];
            let municipality_slug = "municipality_" + name.split('_')[1];
               


           
            

            formValuesLicensePOE.districtFilter.forEach((district) => {
                        if (value.includes(district.id)){

                                municipalityFilter.push(...district.municipalities)
                        }

                    })
            municipalityFilter.sort((a, b) => a.name.localeCompare(b.name))
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value,
                [municipality_slug]: municipalityFilter.filter((municipality) => formValuesLicensePOE[municipality_slug].includes(municipality.id)).map(municipality => municipality.id),
                municipalityFilter
            });


        }
        else if (["municipality_1", "municipality_2", "municipality_3"].includes(name)) {
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value,

            })
        } else if (["east_1", "east_2"].includes(name)){
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value,

            })
            let errorMessage = "";
           
            if (String(value) == "90-00-00" || String(value)==""){
                setEastError(errorMessage+"fill up this field")
                setEastStatus(true);
                return true;
            }
            let temp = String(value).split("-");
            
             if(parseInt(temp[0])>=90){
                 errorMessage = "degree must be less than 90 degree,"
             }
            if (temp.length > 1 && parseInt(temp[1]) > 60) {
                errorMessage = errorMessage +"minute must be less than or equal to 60  minute,"
            }
            if (temp.length > 2 && parseInt(temp[2]) > 60) {
                errorMessage = errorMessage + "& second must be less than or equal to 60  second.";
            }
            if (errorMessage!=""){
                setEastStatus(true);
                setEastError(errorMessage);
                return true;
            }
            setEastStatus(false);
            
            
        }
        else if (["west_1","west_2"].includes(name)) {
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value,

            })
            let errorMessage = "";
            if (String(value) == "90-00-00") {
                setWestError(errorMessage + "fill up this field")
                setWestStatus(true);
                return true;
            }
            let temp = String(value).split("-");

            if (parseInt(temp[0]) > 90) {
                errorMessage = "degree must be less than 90 degree,"
            }
            if (temp.length > 1 && parseInt(temp[1]) > 60) {
                errorMessage = errorMessage + "minute must be less than or equal to 60  minute,"
            }
            if (temp.length > 2 && parseInt(temp[2]) > 60) {
                errorMessage = errorMessage + "& second must be less than or equal to 60  second.";
            }
            if (errorMessage != "") {
                setWestStatus(true);
                setWestError(errorMessage);
                return true;
            }
            setWestStatus(false);


        }
        else if (["north_1", "north_2"].includes(name)) {
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value,

            })
            let errorMessage = "";
            if (String(value) == "90-00-00") {
                setNorthError(errorMessage + "fill up this field")
                setNorthStatus(true);
                return true;
            }
            let temp = String(value).split("-");

            if (parseInt(temp[0]) >= 90) {
                errorMessage = "degree must be less than 90 degree,"
            }
            if (temp.length > 1 && parseInt(temp[1]) > 60) {
                errorMessage = errorMessage + "minute must be less than or equal to 60 minute,"
            }
            if (temp.length > 2 && parseInt(temp[2]) > 60) {
                errorMessage = errorMessage + "& second must be less than or equal to 60 second.";
            }
            if (errorMessage != "") {
                setNorthStatus(true);
                setNorthError(errorMessage);
                return true;
            }
            setNorthStatus(false);


        }
        else if (["south_1", "south_2"].includes(name)) {
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value,

            })
            let errorMessage = "";
            if (String(value) == "90-00-00") {
                setSouthError(errorMessage + "fill up this field")
                setSouthStatus(true);
                return true;
            }
            let temp = String(value).split("-");

            if (parseInt(temp[0]) >= 90) {
                errorMessage = "degree must be less than 90 degree,"
            }
            if (temp.length > 1 && parseInt(temp[1]) > 60) {
                errorMessage = errorMessage + "minute must be less than or equal to 60 minute,"
            }
            if (temp.length > 2 && parseInt(temp[2]) > 60) {
                errorMessage = errorMessage + "& second must be less than or equal to 60 second.";
            }
            if (errorMessage != "") {
                setSouthStatus(true);
                setSouthError(errorMessage);
                return true;
            }
            setSouthStatus(false);
        } else if (name == "from" || name == "to" || name == "date_of_commencing_the_work" || name == "date_of_completing_the_work" || name == "license_issue_date"){
           
              var nepaliDate = new NepaliDate(new Date(value))
              nepaliDate = nepaliDate.format('YYYY-MM-DD')
              setFormValuesLicensePOE({
                  ...formValuesLicensePOE,
                  [name]: value
              });
            eval(`set` + name.charAt(0).toUpperCase() + name.slice(1) + `BS`)(nepaliDate)
         
        }
        else  {
            e.target.autofocus = true;
            //value = value.replace(/\s/g,"").match(/.{1,4}/g)?.join("-").substr(8);
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [name]: value
            });
            if (name == "type_of_electricity_to_be_surveyed_for_production" || name =="means_to_produce_electricity"){
                setHydroItem(value);
            }

        }

    };
    function TextMaskCustom_East(props) {

        const { inputRef, ...other } = props;
        return (
            <MaskedInput
                maskChar={'_'}
                {...other}
                ref={(ref) => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                onChange={props.onChange}
                value={props.value}
                maskPlaceholder="-"
                placeholderChar={'\u2000'}
                showMask
            />
        );
    }

    TextMaskCustom_East.propTypes = {
        inputRef: PropTypes.func.isRequired,
    };
    function TextMaskCustom_West(props) {

        const { inputRef, ...other } = props;

        return (
            <MaskedInput
                maskChar={'_'}
                {...other}
                ref={(ref) => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                placeholderChar={'\u2000'}
                showMask
            />
        );
    }

    TextMaskCustom_West.propTypes = {
        inputRef: PropTypes.func.isRequired,
    };
    function TextMaskCustom_North(props) {

        const { inputRef, ...other } = props;
        return (
            <MaskedInput
                maskPlaceholder={"-"}
                {...other}
                ref={(ref) => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                placeholderChar={'\u2000'}
                onChange={props.onChange}
                value={props.value}
                showMask
            />
        );
    }

    TextMaskCustom_North.propTypes = {
        inputRef: PropTypes.func.isRequired,
    };
    function TextMaskCustom_South(props) {

        const { inputRef, ...other } = props;
        return (
            <MaskedInput
                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                className='form-control'

                type='text'
                maskPlaceholder={"-"}
                value={formValuesLicensePOE[field.slug] != "" ? formValuesLicensePOE[field.slug] : '90-00-00'}

                name={field.slug}
                id={field.slug}

            />
        );
    }
   
    const handleInputChange_ = (value,name) =>{
       var nepaliDate =  new NepaliDate(value)
        var englishDateObj = nepaliDate.getAD();
        var year = englishDateObj.year;
        var tempMonth = englishDateObj.month+1;
        var month = parseInt(englishDateObj.month) > 9 ? tempMonth : "0" + tempMonth;
        var date = parseInt(englishDateObj.date) > 9 ? englishDateObj.date : "0" + englishDateObj.date;
       
        setFormValuesLicensePOE({
            ...formValuesLicensePOE,
            [name]: year+"-"+month+"-"+date
        });
       
    }
   
  
    
  

    TextMaskCustom_South.propTypes = {
        inputRef: PropTypes.func.isRequired,
    };
    useEffect(() => {
        let temp = configItem != "" && (field.slug == "application_letter") ? field.description.replace("........", configItem.name) : field.description;
        
        setDescription(temp);
        if(configItem.id==1){
            if (hydroItem=="hydro"){
                setRiverShow(false);
            }
            
        }
        
        if (['municipality_1', "municipality_2", "municipality_3"].includes(field.slug)) {
         
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [field.slug]: [0],
            });

        } else if (field.type == 'file') {

            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [field.slug]: [],
            })
        } else if (["state_1", "state_2", "state_3"].includes(field.slug)) {
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [field.slug]: [0],
            })
            setStateFlag(true);
        }
        else if (["district_1", "district_2", "district_3"].includes(field.slug)) {
            
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [field.slug]: [0],
            })
            setDistrictFlag(true);
        } else if (field.slug == 'type_of_electricity_to_be_surveyed_for_production' || field.slug == 'means_to_produce_electricity') {

            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                ['type_of_electricity_to_be_surveyed_for_production']: 'hydro',
                ['means_to_produce_electricity']: 'hydro',
            })
        }  else if(field.type=="date_picker"){
            var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
            var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().split('T')[0];
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [field.slug]: localISOTime,
            })
            setCurrentDate(localISOTime);
        } else {
            setFormValuesLicensePOE({
                ...formValuesLicensePOE,
                [field.slug]: null,
            })
        }
        setGeo(Geographical)
        return () => {
            setGeo({})

        };
    }, []);
    useEffect(()=>{
    },[formValuesLicensePOE])


    return (
        <>  
            {groupName != null && groupName != "Genearal" && groupName != "Area where water resources is to be utilized" && groupName != "Boundary" && groupName != "Quantity of water to be utilized" && groupName != "Area of Survey" && groupName.includes("Application for") != true && groupName.includes("Description of main structures and where to be located") != true && groupName.includes("More fields of License for Electricity productio") != true  &&  
                <Grid
                    
                    item
                    xs={12}
                    style={{
                        paddingTop:"10px"
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                        {groupName}
                    </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "5px" }}
                        gutterBottom
                    >
                        {groupDescription}

                        <Divider variant="inset" />
                    </Typography>
                    
                    <br />

                       </Grid>

            }
            {groupName != null && (groupName == "Genearal") &&
                <Grid

                    item
                    xs={12}
                    style={{
                        paddingTop: "10px"
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                    </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "0px" }}
                        gutterBottom
                    >
                    </Typography>

                </Grid>

            }
            {groupName != null && (groupName.includes("Application for") == true) &&
                <Grid

                    item
                    xs={12}
                    style={{
                        paddingTop: "10px"
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                    </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "0px" }}
                        gutterBottom
                    >
                    </Typography>

                </Grid>

            }
            {(formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production == "hydro") && (groupName == "Area where water resources is to be utilized" || groupName == "Boundary" || groupName == "Quantity of water to be utilized" || groupName == "Area of Survey") && 
                < Grid
                    
                    item
            xs={12}
            style={{
                paddingTop: "10px"
            }}
                >
            <Typography
                variant="subtitle1"
                component="div"
                gutterBottom
                style={{ fontWeight: "bold" }}
            >
                {groupName}
            </Typography>
            <Typography
                variant="caption"
                display="block"
                style={{ marginBottom: "5px" }}
                gutterBottom
            >
                {groupDescription}

                        <Divider variant="inset" style={{ marginBottom: "5px" }} />
            </Typography>

            <br />

        </Grid>
     }
            {(formValuesLicensePOE.means_to_produce_electricity != "hydro" && formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production != "hydro") && (groupName == "Area where water resources is to be utilized" || groupName == "Boundary" ||  groupName == "Area of Survey") &&
                < Grid

                    item
                    xs={12}
                    style={{
                        paddingTop: "10px"
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                        {(groupName == "Area where water resources is to be utilized")?"Location of Project":groupName}
                    </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "5px" }}
                        gutterBottom
                    >
                        {groupDescription}

                        <Divider variant="inset" style={{ marginBottom: "5px" }} />
                    </Typography>

                    <br />

                </Grid>
            }
     
            {field.type == "file" && field.slug == "application_letter" && configItem.url !=null &&
                <><Grid
                    key={field.id}
                    item
                    xs={12}
                    style={{
                        padding: "10px",
                        marginTop:"10px",
                        border: "1px solid #ddd",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                        {field.name} 
                        </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "5px" }}
                        gutterBottom
                    >

                        {description}
                    <span style={{ position: "relative", fontSize: "14px", right: "0px" }}><a href={"https://2079.doed.gov.np/"+configItem.url} target="_blank">Download Application Form</a></span>

                    </Typography>
                    <DropzoneArea
                        acceptedFiles={[
                            "application/pdf"

                        ]}
                        name={field.slug}
                        filesLimit={3}
                        dropzoneText="Drop files here or click to upload."
                        onChange={(e) => handleInputChangeDropzone1(field.slug, e)}
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    useChipsForPreview
                    previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                    previewChipProps={{ classes: { root: classes.previewChip } }}
                    previewText="Selected files"
                        maxFileSize={20480000000}
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}

                    />
                    <br />

                    {status && field.required == 1 && formValuesLicensePOE[field.slug] != undefined && formValuesLicensePOE[field.slug].length == 0 && <span style={{ color: "red" }}>You forgot to submit the {field.name}.Upload the {field.name} for submission of application!</span>}
                </Grid>
                
             </>
            }
            {field.type == "file" && field.slug != "application_letter" && 
                <><Grid
                    key={field.id}
                    item
                    xs={12} md="5"
                    style={{
                        padding: "10px",
                        marginBottom: "10px",
                        border: "1px solid #ddd",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                    >
                        {field.name}
                    </Typography>
                    <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "5px" }}
                        gutterBottom
                    >

                   {description}
                    </Typography>
                    <DropzoneArea
                        acceptedFiles={[
                            "application/pdf",
                            "application/kml",
                            "application/shp"

                        ]}
                        name={field.slug}
                        filesLimit={3}
                        dropzoneText="Drop files here or click to upload."
                        onChange={(e) => handleInputChangeDropzone1(field.slug, e)}
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    useChipsForPreview
                    previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                    previewChipProps={{ classes: { root: classes.previewChip } }}
                    previewText="Selected files"
                        maxFileSize={20480000000}
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}
                        
                    />
                    <br />

                    {/* {status &&  field.required == 1 && formValuesLicensePOE[field.slug] != undefined && formValuesLicensePOE[field.slug].length == 0 && <span style={{ color: "red" }}>You forgot to submit the {field.name}.Upload the {field.name} for submission of application!</span>} */}
                    </Grid>
                <Grid
                    key={field.id*1000}
                    item
                    xs={1}
                   
                >
                </Grid>
            </>
            }
           


            {field.type == "dropdown" &&

                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel shrink>{field.name}</InputLabel>

                        <Select
                            name={field.slug}
                            label={field.name}
                            multiple={field.multiple == 0 ? false : true}
                            value={formValuesLicensePOE[field.slug]}
                            variant="outlined"

                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                        >
                            <MenuItem key={0} value={0}>
                                Select Type
                            </MenuItem>

                            {Object.keys(field.option).map((item) => {
                                return (<MenuItem key={item} value={item}>
                                    {
                                        field.option[item]
                                    }
                                </MenuItem>)
                            }


                            )}

                        </Select>
                    </FormControl>
                    <br />

                    {status && field.required == 1 && formValuesLicensePOE[field.slug] == "0" && <span style={{ color: "red" }}>Please select this field {field.name}.</span>}
                </Grid>

            }





            {field.type == "input" && field.slug != 'name_of_river' && field.slug != 'quantity_of_water_to_be_utilized' && field.slug != 'name_of_water_resources' && !["district_1", "district_2", "district_3"].includes(field.slug) && !['municipality_1', "municipality_2", "municipality_3"].includes(field.slug) && !["state_1", "state_2", "state_3"].includes(field.slug) && !["east_1", "east_2", "west_1", "west_2", "south_1", "south_2", "north_1", "north_2"].includes(field.slug) &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl}>

                        <TextField
                            id={field.slug}
                            name={field.slug}
                            type="text"
                            variant="outlined"
                            label={field.name}
                            value={formValuesLicensePOE[field.slug]}
                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                            focused
                        />
                    </FormControl>
                    <br />

                    {status &&  field.required == 1 && formValuesLicensePOE[field.slug] == "" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>

            }

            {
                field.type == "date_picker" && 
                <>
                <Grid key={field.id*222} item xs={6}  md={4} style={{ marginTop: 10, marginBottom: 10 }}>
                    <FormControl variant="outlined" className={classes.formControl} >
                        <TextField
                            name={field.slug}
                                label={field.name.charAt(0).toUpperCase() + field.name.slice(1) + " in AD"}
                            type="date"
                            variant="outlined"
                                value={formValuesLicensePOE[field.slug] != "" ?formValuesLicensePOE[field.slug]:currentDate}
                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                                focused
                        >
                        </TextField>
                    </FormControl>
                        <br />

                        {status &&  field.required == 1 && formValuesLicensePOE[field.slug] == "" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>

<Grid key={field.id*333} item xs={6}  md={4} style={{ marginTop: 10, marginBottom: 10 }}>
<FormControl variant="outlined" className={classes.formControl} >
                            <InputLabel shrink>{field.name.charAt(0).toUpperCase() + field.name.slice(1)} in BS</InputLabel>
                            <NepaliDatePicker inputClassName="MuiInputBase-input MuiOutlinedInput-input"
                                className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
                                value={eval(field.slug+`BS`)}
                                name={field.slug}
                                onChange={(event) => handleInputChange_(event, field.slug)}
                                options={{ calenderLocale: "ne", valueLocale: "en" }} />
                                

</FormControl>
<br />
{status &&  field.required == 1 && formValuesLicensePOE[field.slug] == "" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
</Grid></>
            }
            {
                /*(formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") &&  */  field.type == "input" && ["east_1", "east_2"].includes(field.slug) &&
                <Grid key={field.id} item xs={6}  md={3} style={{ marginTop: 5, marginBottom: 5 }}>

                    <FormControl>
                        <label htmlFor={field.slug} className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">{field.name}</label>
                        <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
                            <MaskedInput
                                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                                className='MuiInputBase-input MuiInput-input'

                                type='text'
                                value={formValuesLicensePOE[field.slug] != "" ? formValuesLicensePOE[field.slug] : '90-00-00'}
                                onChange={handleInputChange}
                                name={field.slug}
                                id={field.slug}

                            />
                        </div>
                    </FormControl>
                        <br />
                        
                        {["east_1", "east_2"].includes(field.slug) && eastStatus && <><span style={{ color: "red" }}>Please  {eastError}</span> <br /></>}
                        {status && field.required == 1 && formValuesLicensePOE[field.slug] == "90-00-00" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>
            }
            {
               /* (formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") && */field.type == "input" && ["west_1", "west_2"].includes(field.slug) &&
                <Grid key={field.id} item xs={6}  md={3} style={{ marginTop: 5, marginBottom: 5 }}>

                    <FormControl>
                        <label htmlFor={field.slug} className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">{field.name}</label>
                        <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
                            <MaskedInput
                                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                                className='MuiInputBase-input MuiInput-input'

                                type='text'
                                value={formValuesLicensePOE[field.slug] != "" ? formValuesLicensePOE[field.slug] : '90-00-00'}
                                onChange={handleInputChange}
                                name={field.slug}
                                id={field.slug}

                            />
                        </div>
                    </FormControl>
                    <br />
                        {["west_1", "west_2"].includes(field.slug) && westStatus && <><span style={{ color: "red" }}>Please  {westError}</span> <br /></>}
                    {status && field.required == 1 && formValuesLicensePOE[field.slug] == "90-00-00" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>
            }

            {
               /* (formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") && */   field.type == "input" && ["north_1", "north_2"].includes(field.slug) &&
                <Grid key={field.id} item xs={6}  md={3} style={{ marginTop: 5, marginBottom: 5 }}>

                    <FormControl>
                        <div style={{ display: "none" }}>
                            <InputLabel htmlFor="hidden">{field.name}</InputLabel>
                            <Input key="hidden"
                                value="hidden"


                                id={"hidden"}
                            />
                        </div>
                        <label htmlFor={field.slug} className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">{field.name}</label>
                        <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
                            <MaskedInput
                                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                                className='MuiInputBase-input MuiInput-input'
                                maskPlaceholder='90-00-00'
                                type='text'
                                value={formValuesLicensePOE[field.slug] != "" ? formValuesLicensePOE[field.slug] : '90-00-00'}
                                onChange={handleInputChange}
                                name={field.slug}
                                id={field.slug}
                                required={true}

                            />
                        </div>
                    </FormControl>
                        <br />
                        {northStatus && <><span style={{ color: "red" }}> Please  {northError}</span> <br /></>}
                        {status && field.required == 1 && formValuesLicensePOE[field.slug] == "90-00-00" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>
            }
            {
                /*(formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") && */ field.type == "input" && ["south_1", "south_2"].includes(field.slug) &&
                <Grid key={field.id} item xs={6}  md={3} style={{ marginTop: 5, marginBottom: 5 }}>

                    <FormControl>
                        <div style={{ display: "none" }}>
                            <InputLabel htmlFor="hidden">{field.name}</InputLabel>
                            <Input key="hidden"
                                value="hidden"


                                id={"hidden"}
                            />
                        </div>
                        <label htmlFor={field.slug} className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">{field.name}</label>
                        <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
                            <MaskedInput
                                mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
                                className='MuiInputBase-input MuiInput-input'
                                maskPlaceholder='90-00-00'
                                type='text'
                                value={formValuesLicensePOE[field.slug] != "" ? formValuesLicensePOE[field.slug] : '90-00-00'}
                                onChange={handleInputChange}
                                name={field.slug}
                                id={field.slug}
                                required={true}

                            />
                        </div>
                    </FormControl>
                    <br />
                    {southStatus && <><span style={{ color: "red" }}> Please  {southError}</span> <br /></>}
                    {status && field.required == 1 && formValuesLicensePOE[field.slug] == "90-00-00" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>
            }
            {/*(formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production == "hydro" || configItem.id == 6 || configItem.id==7) && */field.type == "input" && ["state_1", "state_2", "state_3"].includes(field.slug)
                &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl} >
                        <InputLabel shrink>Select Province</InputLabel>
                       
                        <Select
                            name={field.slug}
                            label={field.name}
                            onChange={handleInputChange}
                            value={!formValuesLicensePOE[field.slug]? [0] : formValuesLicensePOE[field.slug]}
                            multiple
                            
                        >
                            <MenuItem key={0} value={0}>
                                {'Select ' + field.name}
                            </MenuItem>
                            {geos.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <br />

                    {status && field.required == 1 && (formValuesLicensePOE[field.slug] == "" || formValuesLicensePOE[field.slug] == "0") && <span style={{ color: "red" }}>Please select this field {field.name}.</span>}
                </Grid>
            }
            {field.type == "input" && ["district_1", "district_2", "district_3"].includes(field.slug)
                &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl} >
                        <InputLabel>{'Select ' + field.name}</InputLabel>
                      
                        <Select
                            name={field.slug}
                            label={field.name}
                            value={formValuesLicensePOE[field.slug]}
                            multiple
                             onChange={handleInputChange}
                            
                            
                        >
                            <MenuItem key={0} value={0}>
                                {'Select ' + field.name}
                            </MenuItem>
                            {(formValuesLicensePOE.districtFilter || []).map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.name}

                            </MenuItem>
                                    ))
                           }
                            
                        </Select>
                    </FormControl>
                    <br />

                    {status && field.required == 1 && (formValuesLicensePOE[field.slug] == "" || formValuesLicensePOE[field.slug] == "0") && <span style={{ color: "red" }}>Please select this field {field.name}.</span>}
                </Grid>
            }

            {
               field.type == "input" && ['municipality_1', "municipality_2", "municipality_3"].includes(field.slug)
                &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl} >
                            <InputLabel>{'Select ' +field.name}</InputLabel>
                        <Select
                            name={field.slug}
                            label={field.name}
                            value={formValuesLicensePOE[field.slug] ? formValuesLicensePOE[field.slug] : [0]}
                            multiple
                            onChange={handleInputChange}
                            
                        >
                            <MenuItem key={0} value={0}>
                               {'Select ' + field.name}
                            </MenuItem>



                                {(formValuesLicensePOE.municipalityFilter || []).map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}

                                    </MenuItem>
                                ))
                                }
                        </Select>
                    </FormControl>
                        <br />

                        {status && field.required == 1 && (formValuesLicensePOE[field.slug] == "" || formValuesLicensePOE[field.slug] == 0) && <span style={{ color: "red" }}>Please select this field {field.name}.</span>}
                </Grid>
            }
            {(formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") && field.type == "input" && field.slug == 'name_of_river' &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl}>

                        <TextField
                            id={field.slug}
                            name={field.slug}
                            type="text"
                            variant="outlined"
                            label={field.name}
                            value={formValuesLicensePOE[field.slug]}
                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                            focused
                            
                        />
                    </FormControl>
                    <br/>

                    {status &&  field.required == 1 && formValuesLicensePOE[field.slug] == "" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>
           
            }
            {(formValuesLicensePOE.means_to_produce_electricity == "hydro" || formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") && field.type == "input" && field.slug == 'quantity_of_water_to_be_utilized' &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl}>

                        <TextField
                            id={field.slug}
                            name={field.slug}
                            type="text"
                            variant="outlined"
                            label={field.name}
                            value={formValuesLicensePOE[field.slug]}
                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                            focused
                        />
                    </FormControl>
                    <br />

                    {status &&  field.required == 1 && formValuesLicensePOE[field.slug] == "" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>

            }
            {(formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production == "hydro" && formValuesLicensePOE.type_of_electricity_to_be_surveyed_for_production=="hydro") && field.type == "input" && field.slug == 'name_of_water_resources' &&
                <Grid key={field.id} item xs={6}  md={4} style={{ marginTop: 5, marginBottom: 5 }}>
                    <FormControl variant="outlined" className={classes.formControl}>

                        <TextField
                            id={field.slug}
                            name={field.slug}
                            type="text"
                            variant="outlined"
                            label={field.name}
                            value={formValuesLicensePOE[field.slug]}
                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                            focused
                        />
                    </FormControl>
                </Grid>

            }
            {field.type == "textarea"  &&
                <Grid key={field.id} item xs={12} style={{ marginTop: 5, marginBottom: 15 }}>
                    <InputLabel style={{marginBottom:"10px"}}>{field.name}</InputLabel>
                    <FormControl variant="outlined" className={classes.formControl}>
                        
                        <TextareaAutosize
                            id={field.slug}
                            name={field.slug}
                            label={field.name}
                            aria-label="minimum height"
                            minRows={10}
                            placeholder={field.description}
                            value={formValuesLicensePOE[field.slug]}
                            onChange={handleInputChange}
                            inputlabelprops={{
                                shrink: true,
                            }}
                            style={{ width: "100%" }}
                        />
                        
                    </FormControl>
                    <br />

                    {status && field.required == 1 && formValuesLicensePOE[field.slug] == "" && <span style={{ color: "red" }}>Please fill up this field {field.name}.</span>}
                </Grid>

            }
        </>

    );
}
